import { render, staticRenderFns } from "./AuditTrailPortalAdmin.vue?vue&type=template&id=819d2670&scoped=true"
import script from "./AuditTrailPortalAdmin.vue?vue&type=script&lang=js"
export * from "./AuditTrailPortalAdmin.vue?vue&type=script&lang=js"
import style0 from "./AuditTrailPortalAdmin.vue?vue&type=style&index=0&id=819d2670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819d2670",
  null
  
)

export default component.exports